import { combineEpics } from "redux-observable";
import tenantPageEpics from "./views/Tenant/epics/TenantPageEpic.js";
import history from "@ane/core/lib/CreateHistory";
import { produceTenantRouteQueryStringSyncEpics } from "./views/Tenant/ducks/TenantUserContext.js";
const tenantRouteQueryStringSyncEpics = produceTenantRouteQueryStringSyncEpics(history);
const ModuleEpic = combineEpics(tenantPageEpics, tenantRouteQueryStringSyncEpics);
export {
  ModuleEpic as default,
  tenantPageEpics
};
//# sourceMappingURL=epics.js.map
